/**
 * Catch-all stub for Containd app modules not needed for render-only pipeline.
 * Named exports cover every import rewritten by sync-from-containd.sh.
 */

/* eslint-disable @typescript-eslint/no-explicit-any */

const stub: any = new Proxy(function appStub() {}, {
  get: () => stub,
  apply: () => stub,
  construct: () => stub,
});

export default stub;

export type BendPoint = any;
export type GraphEdgeAnchor = any;
export type GraphEdgeData = any;
export type GraphEdgeLabel = any;
export type GraphEdgeStyle = any;
export type ResolvedGraphEdge = any;
export type PlotSeries = any;

/** Minimal stub for chart box-plot summaries (Vite/Rollup needs a real named export). */
export const StatisticsHelpers = {
  fiveNumberSummary(values: number[]): [number, number, number, number, number] {
    if (!values.length) return [0, 0, 0, 0, 0];
    const sorted = [...values].filter((n) => Number.isFinite(n)).sort((a, b) => a - b);
    if (!sorted.length) return [0, 0, 0, 0, 0];
    const q = (p: number) => {
      const idx = (sorted.length - 1) * p;
      const lo = Math.floor(idx);
      const hi = Math.ceil(idx);
      if (lo === hi) return sorted[lo]!;
      return sorted[lo]! + (sorted[hi]! - sorted[lo]!) * (idx - lo);
    };
    return [sorted[0]!, q(0.25), q(0.5), q(0.75), sorted[sorted.length - 1]!];
  },
};

export const AICreationQueueService = stub;
export const AiFeatureGateService = stub;
export const CANVAS_CONSTANTS = stub;
export const CategoryDefinitionService = stub;
export const ObjectCreationMethod = stub;
export const buildThemeColorPalettes = stub;
export const canvasUpdateCoordinator = stub;
export const captureImageWithCamera = stub;
export const changeParentWithHistory = stub;
export const countContainerChildren = stub;
export const countDirectChildren = stub;
export const countLeafChildren = stub;
export const flushPendingLayoutSaves = stub;
export const getActiveTheme = stub;
export const getAllItemsForTree = stub;
export const getChildren = stub;
export const getDescendantChildCounts = stub;
export const getDescendants = stub;
export const getItem = stub;
export const getItemDepth = stub;
export const padEmbeddingsToLength = stub;
export const parseGraphEdge = stub;
export const patchCanvasItemsVisualFields = stub;
export const requestTemplateDisplayRefresh = stub;
export const resolveSvgGraphics = stub;
export const saveItemWithHistory = stub;
export const scheduleEmbeddingBackfill = stub;
export const selectImagesFromGallery = stub;
export const serializeGraphEdge = stub;
export const upsertItem = stub;
export const useSettingsStore = {
  getState: () => ({}),
};
export const ImageStorage = stub;
export const BarcodeService = stub;
export const t = (k: string) => k;

/* auto-generated stub aliases (sync-from-containd.sh) */
export const AppDateTimeFormatOptions = stub;
export const AppHostBridge = stub;
export const AppHostBridgeAdapters = stub;
export const BatchSessionPresentationMode = stub;
export const BendPoint = stub;
export const DocumentImportError = stub;
export const GraphEdgeAnchor = stub;
export const GraphEdgeData = stub;
export const GraphEdgeLabel = stub;
export const GraphEdgeStyle = stub;
export const ItemDefinition = stub;
export const LAYOUT_ENABLED_VARIABLE_KEY = stub;
export const LayoutSelectionStore = stub;
export const PlotSeries = stub;
export const ResolvedGraphEdge = stub;
export const acquireSingleImage = stub;
export const addDocumentFromPicker = stub;
export const alignDocumentArrays = stub;
export const appendStoredDocument = stub;
export const applyElementDefaultsOnItem = stub;
export const awaitItemScriptQueueIdle = stub;
export const beginLoadingSession = stub;
export const coerceToEnabledLayoutIndex = stub;
export const createActionHostBridgeSurface = stub;
export const createCanvasSvgBackgroundHostAdapters = stub;
export const createCountdownAdapters = stub;
export const createFileTableHostAdapter = stub;
export const createItemFromElementDefinition = stub;
export const createLogScriptAdapters = stub;
export const createObjectTemplateAware = stub;
export const createPersistMutationsAdapter = stub;
export const createRelativeDataAdapters = stub;
export const createReminderAdapters = stub;
export const createRootItemFromTemplate = stub;
export const createTemplateChildObject = stub;
export const endLoadingOwnerSession = stub;
export const enqueueItemScriptTurn = stub;
export const ensureInternalProductCode = stub;
export const formatAppDateTime = stub;
export const formatDocumentListViewSubtitle = stub;
export const increment = stub;
export const isLayoutIndexEnabled = stub;
export const logger = stub;
export const normalizeLayoutEnableMask = stub;
export const noteCreation = stub;
export const notifyLiveSyncLocalWake = stub;
export const overlayLiveCanvasGeometry = stub;
export const patchCanvasItemRelationFields = stub;
export const preserveLiveCanvasGeometryOnSave = stub;
export const readRawLayoutEnableMask = stub;
export const reconcileEmbeddings = stub;
export const removeStoredDocumentAtAndDeleteFile = stub;
export const requestStartBatchSession = stub;
export const resolveEffectiveLayoutEnableMask = stub;
export const resolveFormatOptions = stub;
export const resolveOnGraphChangeLifecycleIds = stub;
export const resolveTemplateAction = stub;
export const resumeDeferredItemCreationLifecycle = stub;
export const setElementTypeOnItem = stub;
export const setMaskBit = stub;
export const showAppErrorToast = stub;
export const tracePhase = stub;
export const tracePhaseIfSlow = stub;
export const useLoadingStore = stub;
export const wouldDisableLastEnabled = stub;
export type AICreationQueueService = any;
export type AiFeatureGateService = any;
export type AppDateTimeFormatOptions = any;
export type AppHostBridge = any;
export type AppHostBridgeAdapters = any;
export type BatchSessionPresentationMode = any;
export type CANVAS_CONSTANTS = any;
export type CategoryDefinitionService = any;
export type DocumentImportError = any;
export type ItemDefinition = any;
export type LAYOUT_ENABLED_VARIABLE_KEY = any;
export type LayoutSelectionStore = any;
export type ObjectCreationMethod = any;
export type StatisticsHelpers = any;
export type acquireSingleImage = any;
export type addDocumentFromPicker = any;
export type alignDocumentArrays = any;
export type appendStoredDocument = any;
export type applyElementDefaultsOnItem = any;
export type awaitItemScriptQueueIdle = any;
export type beginLoadingSession = any;
export type buildThemeColorPalettes = any;
export type canvasUpdateCoordinator = any;
export type changeParentWithHistory = any;
export type coerceToEnabledLayoutIndex = any;
export type countContainerChildren = any;
export type countDirectChildren = any;
export type countLeafChildren = any;
export type createActionHostBridgeSurface = any;
export type createCanvasSvgBackgroundHostAdapters = any;
export type createCountdownAdapters = any;
export type createFileTableHostAdapter = any;
export type createItemFromElementDefinition = any;
export type createLogScriptAdapters = any;
export type createObjectTemplateAware = any;
export type createPersistMutationsAdapter = any;
export type createRelativeDataAdapters = any;
export type createReminderAdapters = any;
export type createRootItemFromTemplate = any;
export type createTemplateChildObject = any;
export type endLoadingOwnerSession = any;
export type enqueueItemScriptTurn = any;
export type ensureInternalProductCode = any;
export type flushPendingLayoutSaves = any;
export type formatAppDateTime = any;
export type formatDocumentListViewSubtitle = any;
export type getActiveTheme = any;
export type getAllItemsForTree = any;
export type getChildren = any;
export type getDescendantChildCounts = any;
export type getDescendants = any;
export type getItem = any;
export type getItemDepth = any;
export type increment = any;
export type isLayoutIndexEnabled = any;
export type logger = any;
export type normalizeLayoutEnableMask = any;
export type noteCreation = any;
export type notifyLiveSyncLocalWake = any;
export type overlayLiveCanvasGeometry = any;
export type padEmbeddingsToLength = any;
export type parseGraphEdge = any;
export type patchCanvasItemRelationFields = any;
export type patchCanvasItemsVisualFields = any;
export type preserveLiveCanvasGeometryOnSave = any;
export type readRawLayoutEnableMask = any;
export type reconcileEmbeddings = any;
export type removeStoredDocumentAtAndDeleteFile = any;
export type requestStartBatchSession = any;
export type requestTemplateDisplayRefresh = any;
export type resolveEffectiveLayoutEnableMask = any;
export type resolveFormatOptions = any;
export type resolveOnGraphChangeLifecycleIds = any;
export type resolveSvgGraphics = any;
export type resolveTemplateAction = any;
export type resumeDeferredItemCreationLifecycle = any;
export type saveItemWithHistory = any;
export type scheduleEmbeddingBackfill = any;
export type serializeGraphEdge = any;
export type setElementTypeOnItem = any;
export type setMaskBit = any;
export type showAppErrorToast = any;
export type tracePhase = any;
export type tracePhaseIfSlow = any;
export type useLoadingStore = any;
export type useSettingsStore = any;
export type wouldDisableLastEnabled = any;
